import { companyService } from '../services/companyService';
import { userCompaniesService } from '../services/userCompaniesService';

/**
 * Load supplier profile for the signed-in user (private copy or user-scoped overlay).
 * Prefer GET /users/{userId}/companies/{ticker}, then GET /companies/{ticker}?userId=.
 */
export async function fetchUserScopedSupplier(userId, ticker) {
  const uid = userId != null ? String(userId).trim() : '';
  const symbol = ticker != null ? String(ticker).trim() : '';
  if (!uid || !symbol) return null;

  const userRes = await userCompaniesService.getUserCompanyByTicker(uid, symbol);
  if (userRes.success && userRes.data) {
    return userRes.data;
  }

  const scopedRes = await companyService.getCompanyByTicker(symbol, uid);
  if (scopedRes.success && scopedRes.data) {
    return scopedRes.data;
  }

  return null;
}
